import { REGISTER_STEPS } from '../../constants/registerSteps';

export const REGISTER_UPDATE_STEP = 'REGISTER_UPDATE_STEP';
export const REGISTER_UPDATE_AUTH_BY_GOOGLE = 'REGISTER_UPDATE_AUTH_BY_GOOGLE';
export const REGISTER_UPDATE_DATA = 'REGISTER_UPDATE_DATA';
export const REGISTER_UPDATE_USER_ID = 'REGISTER_UPDATE_USER_ID';
export const REGISTER_UPDATE_COMPANY_ID = 'REGISTER_UPDATE_COMPANY_ID';
export const REGISTER_RESET = 'REGISTER_RESET';

const initialState = {
  currentStep: 0,
  authByGoogle: {},
  steps: {
    [REGISTER_STEPS.SIGN_IN_INFO]: { email: '', password: '', passwordConfirmation: '' },
    [REGISTER_STEPS.USER_INFO]: { name: '', cpf: '', phone: '' },
    [REGISTER_STEPS.COMPANY_INFO]: { cnpj: '', name: '', phone: '' },
    [REGISTER_STEPS.COMPANY_ADDRESS]: {
      zipCode: '',
      street: '',
      number: '',
      neighborhood: '',
      complement: '',
      city: '',
      state: '',
    },
    [REGISTER_STEPS.COLLABORATORS]: { collaboratorSizeRangeLabel: '' },
    [REGISTER_STEPS.DISCOUNT]: { discountCoupon: '' },
  },
  userId: '',
  companyId: '',
};

function registerStepReducer(state = initialState, action) {
  switch (action.type) {
    case REGISTER_UPDATE_STEP:
      return { ...state, currentStep: action.payload };
    case REGISTER_UPDATE_AUTH_BY_GOOGLE:
      return { ...state, authByGoogle: action.payload };
    case REGISTER_UPDATE_DATA: {
      const trimmedData = Object.fromEntries(
        Object.entries(action.payload.data).map(([key, value]) => [
          key,
          typeof value === 'string' ? value.trim() : value,
        ]),
      );
      return {
        ...state,
        steps: {
          ...state.steps,
          [action.payload.step]: {
            ...state.steps[action.payload.step],
            ...trimmedData,
          },
        },
      };
    }
    case REGISTER_UPDATE_USER_ID:
      return { ...state, userId: action.payload };
    case REGISTER_UPDATE_COMPANY_ID:
      return { ...state, companyId: action.payload };
    case REGISTER_RESET:
      return initialState;
    default:
      return state;
  }
}

export default registerStepReducer;
